import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Notes.sass'
import withStore from '../../Components/Unstated/withStore'
import NotesStore from './Store/NotesStore'
import { withRouter } from 'react-router-dom'
import DashboardNotes from './Components/DashboardNotes'

class Notes extends Component {
  componentDidMount() {
    console.log('init')
    const { type, enrollment, chapters, courseID } = this.props
    if (type === 'teacher') {
      this.props.notesStore.initTeacherNotes(chapters, courseID)
    } else {
      this.props.notesStore.initStudentNotes(enrollment)
    }
  }

  render() {
    return (
      <div className='notesModule' onClick={this.close}>
        <DashboardNotes close={this.close} blockEdit={this.props.blockEdit} />
      </div>
    )
  }

  close = () => {
    const { close = () => {} } = this.props
    close()
  }
}

export default withStore([NotesStore])(withRouter(Notes))

Notes.propTypes = {
  type: PropTypes.oneOf(['teacher', 'student']).isRequired,
  close: PropTypes.func,
}
